import React, { FunctionComponent } from 'react';
import {
  Box,
  Button,
  Icon,
  IconButton,
  InputAdornment,
  TextField,
} from '@mui/material';
import styles from './Login.module.css';
import { LoginElement } from '../LoginElement';

export const MobileView: FunctionComponent = (): JSX.Element => {
  // Page Element
  const loginElement = LoginElement();

  return (
    <React.Fragment>
      <header className={styles.commonHeaderGroup} id="common-navi-bar">
        <img
          className={styles.bbaLogoIcon}
          id="entry-header"
          alt=""
          src="assets/common/bba-logo.svg"
        />
      </header>
      <Box className={styles.mainGroupBox}>
        <Box className={styles.mainGroupTitleBox}>
          <span className={styles.mainGroupTitle}>Welcome Back</span>
          <span className={styles.mainGroupSubtitle}>
            Enter your details to login.
          </span>
        </Box>
        <Box className={styles.divider} />

        {loginElement.loginModeSelection()}

        <Box className={styles.mainGroupCenter}>
          {loginElement.loginMode === 'parentPortal' && (
            <>
              <Box className={styles.mainGroupInputBox}>
                {loginElement.emailInput}
                {/* <Button
                  className={styles.loginMainInputGroupEmailIButton}
                  variant="text"
                  color="primary"
                  onClick={loginElement.forgetEmailButtonClickHandler}
                >
                  forgot email?
                </Button> */}
              </Box>
              <Box className={styles.mainGroupInputBox}>
                {loginElement.passwordInput}
                <Box className={styles.optionsBox}>
                  {loginElement.rememberMeCheckbox}
                  <Button
                    className={styles.loginMainInputGroupEmailIButton}
                    variant="text"
                    color="primary"
                    onClick={loginElement.forgetPasswordButtonClickHandler}
                  >
                    Need Help?
                  </Button>
                </Box>
              </Box>
              {loginElement.loginButton}
            </>
          )}

          {loginElement.loginMode === 'bbl' && (
            <>
              <img
                src={'assets/bigBangLab/use-larger-screen.png'}
                className={styles.useLargerScreenImage}
              />
              <span className={styles.useLargerScreen}>
                Screen size is not supported, please try using a tablet or
                computer to continue.
              </span>
              <Button
                variant="contained"
                sx={{ width: '100%', ':disabled': { color: '#949494' } }}
                fullWidth={true}
                disabled
              >
                Login on Tablet/ Computer
              </Button>
            </>
          )}
          <Box className={styles.noAccountBox}>
            <span
              className={styles.loginMainGroupSignUpTextSpan}
              id="login-main-group-sign-up-text"
            >
              Don’t have an account?
            </span>
            <button
              className={styles.loginMainGroupSignUpButtoButton}
              id="login-main-group-sign-up-button"
              onClick={loginElement.signUpRedirectButtonClickHandler}
            >
              <b className={styles.signUpB}>Sign&nbsp;up</b>
              <span className={styles.span}>.</span>
            </button>
          </Box>
        </Box>
      </Box>
    </React.Fragment>
  );
};
